// Enum defined here: https://github.com/duointeractive/pathwright/blob/1cbffd0e36e5cb4b423871c4cb9f4948337c3b7e/packages/pathwright-graphql/graphql/models/group/types.js#L196
export const COHORT_VISIBILITY = {
  NONE: 0,
  PRIVATE: 5,
  MEMBERS_ONLY: 10,
  PUBLIC: 15
}
